module.exports = __webpack_public_path__ + "img/arrow-down.01c2d0ec.svg";